(function(angular){
	'use strict';
	
	angular
		.module('revealModule')
		.service('RevealService', [
			'$window',
			RevealServiceFunction
		]);
	
	function RevealServiceFunction($window){
		var service = this;

		service.isMiddleOfElementInViewport = function(element){
			var position = element.getBoundingClientRect();
			var middleEdge = position.top + $window.pageYOffset + (element.offsetHeight * 0.5);
			var scrollDepth = $window.pageYOffset + $window.innerHeight;

			return scrollDepth >= middleEdge;
		};

		service.isTopOfElementInViewport = function(element, buffer) {
			var position = element.getBoundingClientRect();
			var preloadBuffer = buffer || 0;
			var topEdge = (position.top + $window.pageYOffset) - preloadBuffer;
			var scrollDepth = $window.pageYOffset + $window.innerHeight;

			return scrollDepth >= topEdge;
		};
	}
})(window.angular);